import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './theme';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SpeakingPage from './pages/SpeakingPage';
import PhilanthropyPage from './pages/PhilanthropyPage';
import AboutMePage from './pages/AboutMePage';
import ArticlesPage from './pages/ArticlesPage';
import ArticlePage from './pages/ArticlePage';
import MentorshipPage from './pages/MentorshipPage';
import ConsultingPage from './pages/ConsultingPage';
import MultiTeamHubPage from './pages/MultiTeamHubPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Admin routes - no header/footer */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          
          {/* Public routes - with header/footer */}
          <Route
            path="/*"
            element={
              <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <Header />
                <Box component="main" sx={{ flex: 1 }}>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/speaking" element={<SpeakingPage />} />
                    <Route path="/philanthropy" element={<PhilanthropyPage />} />
                    <Route path="/about" element={<AboutMePage />} />
                    <Route path="/articles" element={<ArticlesPage />} />
                    <Route path="/article/:slug" element={<ArticlePage />} />
                    <Route path="/mentorship" element={<MentorshipPage />} />
                    <Route path="/consulting" element={<ConsultingPage />} />
                    <Route path="/multi-team-hub" element={<MultiTeamHubPage />} />
                  </Routes>
                </Box>
                <Box id="contact">
                  <Footer />
                </Box>
              </Box>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
